module.exports = __webpack_public_path__ + "static/dallas-bc9fc87bcaa94c2adae85555b34d4071.png";